import axios from '@/plugins/axios'
import { Endpoints, urlBuilder } from '@/connectors/endpoints'

const importManOrgGisGkh = (formData: any) => {
  return axios.post(urlBuilder(Endpoints.IMPORT_MAN_ORG_GIS_GKH), formData)
}

export default importManOrgGisGkh
